import { lazy } from 'react';
import i18next from 'i18next';
import permissions from '@shared/config/permissions';
import { PermissionsTestingIcon } from '@shared/ui/icons';
import { isPermissionsTestingEnabled } from '@shared/config/env';

const PermissionsTesting = lazy(() => import('@pages/permissions-testing'));

const PERMISSIONS_TESTING_PAGE = {
  path: '/:currentAccountUuid/permissions-testing',
  exact: true,
  additional: {
    component: PermissionsTesting,
    protected: true,
    permission: permissions.PERMISSIONS_MANAGE,
    title: i18next.t('titles:permissionsTesting'),
    icon: PermissionsTestingIcon,
    breadcrumb: {
      isRoot: true,
      label: ({ state }) => state.i18n?.titles?.permissionsTesting || 'Permissions Testing',
    },
  },
};

// Lock one of two: on a production build `PERMISSIONS_TESTING_ROUTES`
// below is `{}`, so there is no route entry and no menu item. The
// `lazy(() => import(...))` call above is still statically reachable
// (it sits outside the ternary), so webpack emits the page's chunk
// regardless of this lock — production only loses the route and the
// nav entry, nothing more. Lock two is `permission: PERMISSIONS_MANAGE`
// above, which the existing ProtectedRoute / Sidebar machinery
// enforces, and the backend answering 404 for the underlying API is
// the lock that actually matters.
export const PERMISSIONS_TESTING_ROUTES = isPermissionsTestingEnabled()
  ? { page: PERMISSIONS_TESTING_PAGE }
  : {};
